import { useState, useEffect } from 'react'
import { Button } from 'reactstrap'
import { FaPen } from 'react-icons/fa'
import swal from 'sweetalert'
import { EditProposalFileHtmlContainer } from './EditProposalFileHtmlContainer'
import s from './EditHtml.scss'
import { useLoading } from 'hooks'
import { makeGetRequest } from 'utils/api'
import { toCategories } from './serializers'

const EditHtml = ({
  proposalId,
  content,
  fileName,
  proposal,
  templateId,
  isHtmlProposal,
  pages,
  status,
  pageType
}) => {
  const [showEditFileModal, setShowEditFileModal] = useState(false)
  const [categories, setCategories] = useState([])
  const [, withLoadingLocks] = useLoading()

  useEffect(() => {
    ;(async () => {
      if (!proposalId || !isHtmlProposal) return
      const result = await withLoadingLocks(makeGetRequest('/v1/proposaltemplates/html/sections'))
      const list = toCategories(result)
      setCategories(list)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposalId, isHtmlProposal])

  const toggleEditFileModal = () => {
    setShowEditFileModal(!showEditFileModal)
  }

  const editProposal = async () => {
    if (status === 'INTERNALREVIEW') {
      await swal({
        text: 'The editing function of the proposal is not available when proposal is in review stage.'
      })
    } else {
      toggleEditFileModal()
    }
  }

  return (
    <>
      <Button data-cy="edit_proposal_btn" className={s.fileBtn} onClick={editProposal}>
        <FaPen />
        Edit
      </Button>
      <EditProposalFileHtmlContainer
        proposalId={proposalId}
        fileName={fileName}
        content={content}
        proposal={proposal}
        showEditFileModal={showEditFileModal}
        toggleEditFileModal={toggleEditFileModal}
        templateId={templateId}
        isHtmlProposal={isHtmlProposal}
        pages={pages}
        categories={categories}
        pageType={pageType}
      />
    </>
  )
}

export default EditHtml
